document.addEventListener("DOMContentLoaded", function () {
  initializeShopifyFormatMoney();
  handleMcMainProductImagesCarousel();
  handleMcMainProductAddToCart();
  handleMcMainProductVariantSelector();
});

// Expose functions globally for manual initialization
window.handleMcMainProductImagesCarousel = handleMcMainProductImagesCarousel;
window.handleMcMainProductAddToCart = handleMcMainProductAddToCart;
window.handleMcMainProductVariantSelector = handleMcMainProductVariantSelector;

/**
 * Handles product image carousel with Swiper.js
 * @param {HTMLElement} container - The container to scope the query selectors to
 */
function handleMcMainProductImagesCarousel(container = document) {
  const mainSwiperElement = container.querySelector(
    ".mc-main-product__image-slider--main",
  );
  const thumbnailSwiperElement = container.querySelector(
    ".mc-main-product__image-slider--thumbs",
  );
  const nextButton = container.querySelector(".mc-main-product-slider__next");
  const prevButton = container.querySelector(".mc-main-product-slider__prev");

  if (
    !mainSwiperElement ||
    !thumbnailSwiperElement ||
    !nextButton ||
    !prevButton
  ) {
    console.warn(
      "Required elements for the product image carousel are missing.",
    );
    return;
  }

  const thumbnailSwiper = new Swiper(thumbnailSwiperElement, {
    spaceBetween: 10,
    slidesPerView: 3,
    freeMode: true,
    watchSlidesProgress: true,
  });

  new Swiper(mainSwiperElement, {
    spaceBetween: 10,
    navigation: { nextEl: nextButton, prevEl: prevButton },
    thumbs: { swiper: thumbnailSwiper },
  });
}

/**
 * Manages add to cart functionality with loading states and cart drawer updates
 */

function handleMcMainProductAddToCart(container = document) {
  const elements = {
    plusBtn: container.querySelector(".mc-main-product__quantity-plus"),
    minusBtn: container.querySelector(".mc-main-product__quantity-minus"),
    quantityInput: container.querySelector(".mc-main-product__quantity-input"),
    form: container.querySelector('form[data-type="add-to-cart-form"]'),
    submitBtn: container.querySelector(".mc-main-product__add-to-cart"),
    cartDrawer: document.querySelector("cart-drawer"),
  };

  if (!Object.values(elements).every(Boolean)) {
    console.warn(
      "Required elements for add to cart functionality are missing.",
    );
    return;
  }

  // Quantity Controls
  elements.plusBtn.addEventListener("click", () => updateQuantity(1));
  elements.minusBtn.addEventListener("click", () => updateQuantity(-1));

  function updateQuantity(change) {
    const currentQuantity = parseInt(elements.quantityInput.value) || 1;
    const newQuantity = Math.max(1, currentQuantity + change);
    elements.quantityInput.value = newQuantity;
  }

  // Add to Cart with Loading States
  elements.form.addEventListener("submit", async (e) => {
    e.preventDefault();

    const originalText = elements.submitBtn.textContent;

    try {
      setLoadingState(true, "ADDING TO CART...");

      const response = await fetch("/cart/add.js", {
        method: "POST",
        body: new FormData(elements.form),
      });

      const data = await response.json();

      if (data && data.id) {
        await updateCartDrawer();
        setLoadingState(false, "ADDED TO CART!");

        setTimeout(() => {
          elements.submitBtn.textContent = originalText;
        }, 2000);
      }
    } catch (error) {
      console.error("Add to cart error:", error);
      setLoadingState(false, "ERROR - TRY AGAIN");

      setTimeout(() => {
        elements.submitBtn.textContent = originalText;
      }, 3000);
    }
  });

  function setLoadingState(isLoading, text) {
    elements.submitBtn.disabled = isLoading;
    elements.submitBtn.textContent = text;
    elements.submitBtn.classList.toggle("loading", isLoading);
  }

  async function updateCartDrawer() {
    try {
      const response = await fetch("/?section_id=cart-drawer");
      const html = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, "text/html");
      const newCartDrawer = doc.querySelector("cart-drawer");

      if (newCartDrawer && elements.cartDrawer) {
        elements.cartDrawer.innerHTML = newCartDrawer.innerHTML;
        elements.cartDrawer.classList.remove("is-empty");
        elements.cartDrawer.classList.add("active");

        if (typeof elements.cartDrawer.open === "function") {
          elements.cartDrawer.open();
        }
      }
    } catch (error) {
      console.error("Error updating cart drawer:", error);
    }
  }
}

/**
 * Handles variant selection, updates URL and price displays
 */
function handleMcMainProductVariantSelector(container = document) {
  const variantSelect = container.querySelector(
    ".mc-main-product__variant-select",
  );

  // Handle products with variant selector
  if (variantSelect) {
    variantSelect.addEventListener("change", async function () {
      const selectedVariantId = this.value;

      try {
        updateURL(selectedVariantId);

        const productHandle = window.location.pathname.split("/").pop();
        const response = await fetch(`/products/${productHandle}.js`);
        const productData = await response.json();

        const selectedVariant = productData.variants.find(
          (variant) => variant.id == selectedVariantId,
        );

        if (selectedVariant) {
          updatePriceDisplays(selectedVariant);
          updateAddToCartButton(selectedVariant);
        }
      } catch (error) {
        console.error("Error updating variant:", error);
      }
    });

    // Trigger initial change for products with variant selector
    if (variantSelect.value) {
      variantSelect.dispatchEvent(new Event("change"));
    }
  } else {
    // Handle products with single variant (no selector)
    handleSingleVariantProduct();
  }

  /**
   * Handles products with only one variant (no variant selector)
   */
  async function handleSingleVariantProduct() {
    try {
      const productHandle = window.location.pathname.split("/").pop();
      const response = await fetch(`/products/${productHandle}.js`);
      const productData = await response.json();

      // Get the first (and only) variant
      const defaultVariant = productData.variants[0];

      if (defaultVariant) {
        // Update URL with variant parameter
        updateURL(defaultVariant.id);

        // Update price displays
        updatePriceDisplays(defaultVariant);
        updateAddToCartButton(defaultVariant);
      }
    } catch (error) {
      console.error("Error updating single variant:", error);
    }
  }

  /**
   * Updates browser URL with selected variant ID
   * @param {string} variantId - The selected variant ID
   */
  function updateURL(variantId) {
    const url = new URL(window.location);
    url.searchParams.set("variant", variantId);
    window.history.replaceState({}, "", url);
  }

  /**
   * Updates price displays based on selected variant
   * @param {Object} variant - The selected variant object
   */
  function updatePriceDisplays(variant) {
    // Update main price display using Shopify's formatMoney
    const priceElement = container.querySelector(
      ".mc-main-product__price-current",
    );
    if (priceElement) {
      priceElement.textContent = formatMoneyWithoutTrailingZeros(variant.price);
    }

    // Handle compare at price logic - same as your Liquid template
    const compareAtPriceElement = container.querySelector(
      ".mc-main-product__price-compare",
    );

    if (variant.compare_at_price && variant.compare_at_price > variant.price) {
      // Show compare at price when it exists and is higher than current price
      if (compareAtPriceElement) {
        compareAtPriceElement.textContent = formatMoneyWithoutTrailingZeros(
          variant.compare_at_price,
        );
        compareAtPriceElement.style.display = "inline";
      }
    } else {
      // Hide compare at price when not applicable
      if (compareAtPriceElement) {
        compareAtPriceElement.classList.add("hidden");
      }
    }

    // Update any other price elements with data-product-price attribute
    const priceElements = container.querySelectorAll("[data-product-price]");
    priceElements.forEach((element) => {
      element.textContent = formatMoneyWithoutTrailingZeros(variant.price);
    });
  }

  /**
   * Updates add to cart button state based on variant availability
   * @param {Object} variant - The selected variant object
   */
  function updateAddToCartButton(variant) {
    const addToCartBtn = container.querySelector(
      ".mc-main-product__add-to-cart",
    );
    if (addToCartBtn) {
      if (variant.available) {
        addToCartBtn.disabled = false;
        addToCartBtn.textContent = "ADD TO CART";
      } else {
        addToCartBtn.disabled = true;
        addToCartBtn.textContent = "SOLD OUT";
      }
    }
  }

  /**
   * Formats money without trailing zeros (.00)
   * @param {number} cents - Price in cents
   * @returns {string} Formatted price string
   */
  function formatMoneyWithoutTrailingZeros(cents) {
    let formatted = Shopify.formatMoney(cents);
    // Remove .00 from the end, even if followed by currency text (e.g. USD)
    return formatted.replace(".00", "");
  }
}

/**
 * Initializes Shopify money formatting with store currency settings
 */
function initializeShopifyFormatMoney() {
  if (!window.Shopify) {
    window.Shopify = {};
  }

  Shopify.formatMoney = function (cents, format) {
    if (typeof cents == "string") {
      cents = cents.replace(".", "");
    }
    var value = "";
    var placeholderRegex = /{{\s*(\w+)\s*}}/;
    var formatString = format || this.money_format;

    function defaultOption(opt, def) {
      return typeof opt == "undefined" ? def : opt;
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultOption(precision, 2);
      thousands = defaultOption(thousands, ",");
      decimal = defaultOption(decimal, ".");
      if (isNaN(number) || number == null) {
        return 0;
      }
      number = (number / 100.0).toFixed(precision);
      var parts = number.split("."),
        dollars = parts[0].replace(
          /(\d)(?=(\d\d\d)+(?!\d))/g,
          "$1" + thousands,
        ),
        cents = parts[1] ? decimal + parts[1] : "";
      return dollars + cents;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case "amount":
        value = formatWithDelimiters(cents, 2);
        break;
      case "amount_no_decimals":
        value = formatWithDelimiters(cents, 0);
        break;
      case "amount_with_comma_separator":
        value = formatWithDelimiters(cents, 2, ".", ",");
        break;
      case "amount_no_decimals_with_comma_separator":
        value = formatWithDelimiters(cents, 0, ".", ",");
        break;
    }
    return formatString.replace(placeholderRegex, value);
  };
}
